import React from 'react';
import styled from 'styled-components';
import {Theme} from "../config/theme";

const Dialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const DialogContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
`;

const DialogTitle = styled.h2`
  margin: 0 0 1rem;
  color: #333;
`;

const DialogMessage = styled.p`
  margin: 0 0 1.5rem;
  color: #666;
`;

const DialogButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

const DialogButton = styled.button<{ primary?: boolean }>`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: ${props => props.primary ? Theme.buttons.warning.bgColor : Theme.buttons.secondary.bgColor};
  color: ${props => props.primary ? Theme.buttons.warning.color : Theme.buttons.secondary.color};
  
  &:hover {
    background: ${props => props.primary ? Theme.buttons.warning.bgColorHoover : Theme.buttons.secondary.bgColorHoover};
  }
`;

interface ResetDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const ResetDialog: React.FC<ResetDialogProps> = ({ onConfirm, onCancel }) => {
  return (
    <Dialog>
      <DialogContent>
        <DialogTitle>Reset Coloring</DialogTitle>
        <DialogMessage>
          Are you sure you want to reset your coloring? This action cannot be undone.
        </DialogMessage>
        <DialogButtons>
          <DialogButton onClick={onCancel}>Cancel</DialogButton>
          <DialogButton onClick={onConfirm} primary>Reset</DialogButton>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  );
};

export default ResetDialog; 